import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Divider, Flex, List, Typography } from 'antd'
import { colorBlack, colorText } from 'src/app/themes/primaryThemeDefault'
import { PenEditIcon } from 'src/assets/icons'
import { IUserPage } from 'src/app/shared/models/userPages.model'

interface FavoriteListProps {
  setIsFavoriteConfirmationModalOpen: (value: boolean) => void
  setIsAccountMenuOpen: (value: boolean) => void
  favoriteList: IUserPage[]
}

const FavoriteList: React.FC<FavoriteListProps> = ({
  favoriteList,
  setIsFavoriteConfirmationModalOpen,
  setIsAccountMenuOpen,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const handleEditOnClick = () => {
    setIsAccountMenuOpen(false)
    setIsFavoriteConfirmationModalOpen(true)
  }
  return (
    <Flex vertical style={{ width: '280px', padding: '8px', maxHeight: '320px' }} gap={8}>
      <Flex justify='space-between'>
        <Typography.Text style={{ fontWeight: '700', color: colorBlack, fontSize: '16px' }}>
          {t('OverallFunctionality:favorite_list_header_label')}
        </Typography.Text>
        <PenEditIcon style={{ cursor: 'pointer' }} onClick={handleEditOnClick} />
      </Flex>
      <Divider style={{ margin: '0' }} />
      <List
        split={false}
        dataSource={favoriteList}
        style={{
          overflowY: 'scroll',
        }}
        renderItem={(item) => (
          <List.Item
            style={{ padding: '8px 0', cursor: 'pointer', color: colorText }}
            onClick={() => {
              navigate(item.path)
            }}
          >
            {item.pageName}
          </List.Item>
        )}
      ></List>
    </Flex>
  )
}

export default FavoriteList
